import { useSelector } from 'react-redux'
import { getUserProfile } from 'app/selectors'
import { useEffect } from 'react'

export const USER_SESSION_ACTION_TYPES = {
  CREATE_SESSION: 'create-session',
  EXCEEDED_SESSIONS: 'exceeded-sessions',
  REVALIDATE_SESSION: 'revalidate-session',
}

/**
 * @function useUserSessionLogger
 * @param {String} type - one of USER_SESSION_ACTION_TYPES
 * @param {String} message
 */
function useUserSessionLogger(type) {
  const user = useSelector(getUserProfile)
  const isBrowser = typeof window !== 'undefined'
  const currentUrl = isBrowser && window.location.href

  useEffect(() => {
    if (isBrowser) {
      const domain = window.location.origin
      const userAgent = window.navigator.userAgent
      fetch(domain + '/api/user-session-logs/', {
        method: 'POST',
        body: JSON.stringify({
          message: `[user-sessions][${type}]: userId: ${user.userId} | email: ${user.email} | mailbox: ${user.mailbox} | ${currentUrl} | ${userAgent}`
        }),
        headers:{
          'Content-Type': 'application/json'
        }
      })
      .catch(err => console.error('useUserSessionLogger error: ', err))
    }
  }, [type, isBrowser, currentUrl])
}

export default useUserSessionLogger
